import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {ButtonOptions} from '../eva-button/eva-button.component';
import {TagTextData} from '../tag-text/tag-text.component';
import { TextAndImageModel } from '../text-and-image/text-and-image/text-and-image.component';
import { Module } from 'projects/common/model/ModuleModel';
import { AbstractComponent } from '../abstract.component';
import { UpaTarget } from 'projects/common/services/upa.service';
import { MediaPictureService } from 'projects/common/services/media-picture.service';

@Component({
  selector: 'empty-state',
  template: `
    <div *ngIf="module?.empty_state_data?.show_title && (module.pretitle || module.title || module.subtitle)" class="titles-outside-modules titles-module-{{module.id}}">
      <text class="empty-state-title" *ngIf="module.pretitle || module.title || module.subtitle" [data]="module"></text>
    </div>

    <div class="eva-3-empty-state-message">
      <div class="empty-state-message-container">
        <div class="empty-state-message-image" [ngClass]="{'custom-image': !!this.textData.picture}" [style.--custom-image]="this.picture" [style.--image-size.px]="this.pictureSize"></div>
        <div class="empty-state-message-content">
          <tag-text [data]="textData.title" class="empty-state-message-title"></tag-text>
          <p class="empty-state-message-description eva-3-body-1">{{textData.text.text}}</p>
          <div *ngIf="button" class="empty-state-message-button">
            <eva-button
              [moduleId]="moduleId"
              [moduleIndex]="moduleIndex"
              [uniqueId]="uniqueId"
              [options]="button"
              (clickEvent)="clickEvent.emit()"></eva-button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./empty-state.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmptyStateComponent extends AbstractComponent implements OnInit {
  static readonly MODULE_ID = 'EmptyStateModule';

  @Input() override module: Module<TextAndImageModel>;
  @Input() moduleIndex: number;
  @Input() moduleId: string;
  @Input() uniqueId?: string;
  @Input() title: TagTextData;
  @Input() text: string;
  @Input() button: ButtonOptions;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter();

  textData: TextAndImageModel;
  picture?: string;
  pictureSize: number;

  constructor(injector: Injector, private mediaPictureService: MediaPictureService) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.module?.data) {
      this.textData = this.module.data;

      this.pictureSize = this.module.data.options?.image_size || 200;
      this.picture = this.module.data.picture && this.mediaPictureService.getMediaUrlByPictureData(this.module.data.picture, this.screenType);
      if (this.picture && !this.picture.startsWith("var(")) {
        this.picture = `url('${this.picture}')`;
      } 
    } else {
      this.textData = {
        title: this.title,
        text: {text: this.text, tag: 'p'},
        button: this.button
      };
    }

    this.upaService.trackView({
        label: this.module?.empty_state_data?.shared_module_id || "EmptyState",
        uniqueId: this.uniqueId,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.EMPTY_STATE,
      });
  }

  override getModuleId(): string {
    return EmptyStateComponent.MODULE_ID;
  }
}
